<form class="mt-5"
      [formGroup]="form"
      (ngSubmit)="addSupplementFile()">

  <div class="formgrid grid">

    <div class="col-12 mb-4">
      <sc-file-upload #fileUpload
                      [validationRules]="dialogData.validationRules$ | async"
                      (uploadCompleted)="onUploadCompleted()">
      </sc-file-upload>
    </div>

    <div class="field col-12">
      <label class="font-bold sc-required-input"
             i18n>Description</label>
      <editor formControlName="description"
              scValidatable
              scLabelText="Description"
              i18n-scLabelText
              placeholder="Add description for link"
              i18n-placeholder
              class="w-full">
      </editor>
    </div>
  </div>

  <p-button [disabled]="form.invalid || !fileUpload.isValid()"
            [loading]="requestInProcess"
            type="submit"
            class="flex justify-content-center mt-3"
            label="Save"
            i18n-labe>
  </p-button>
</form>